/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountingAccountType } from './accountingAccountType';
import { AccountingLedgerType } from './accountingLedgerType';


export interface AccountingAccountFilter { 
    /**
     * The page number of the result (the first page is 0)
     */
    page_number?: number;
    /**
     * The number of items returned in each page
     */
    page_size?: number;
    /**
     * The grouping identifier for accounts e.g. AIRBNB.COM and it can be used for AIRBNB.COM_AR and AIRBNB.COM_AP
     */
    account_identifier?: string;
    account_code?: string;
    ledger_type?: AccountingLedgerType;
    account_type?: AccountingAccountType;
    system?: boolean;
}

